export async function apiFetch(url, options = {}) {
  const auth = JSON.parse(localStorage.getItem("auth") || "{}");
  const token = auth?.token;

  const isFormData = options.body instanceof FormData;

  const headers = {
    ...(options.headers || {}),   // keep existing headers
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(isFormData ? {} : { "Content-Type": "application/json" })
  };

  return fetch(url, {
    ...options,
    headers
  });
}
